import getLatestBotVersion from '~/gql/bot/getLatestBotVersion.gql'

export default {
  getLatestBotVersion
}
